import type { ResourcesConfig } from "aws-amplify";

export const amplifyConfig: ResourcesConfig = {
	API: {
		GraphQL: {
			endpoint: process.env.APPSYNC_API_URL!,
			defaultAuthMode: "userPool",
		},
	},
	Auth: {
		Cognito: {
			identityPoolId: process.env.AUTH_IDENTITY_POOL_ID!,
			userPoolId: process.env.AUTH_USER_POOL_ID!,
			userPoolClientId: process.env.AUTH_USER_POOL_CLIENT_WEB_ID!,
			allowGuestAccess: true,
			signUpVerificationMethod: "code",
			loginWith: {
				username: true,
				email: true,
			},
		},
	},
};
